export { default } from "./Hero"